<template>
  <div>
    <v-list-group v-if="menu.items" :value="menuGroupOpen" class="menu-section">
      <!-- CaseTypeUnfold-->
      <v-list-tile slot="activator">
        <v-list-tile-action>
          <font-awesome-icon v-if="menu.icon && menu.icon.set" size="1x" :icon="[menu.icon.set, menu.icon.code]"></font-awesome-icon>
          <v-icon v-else-if="menu.icon && menu.icon.code">{{menu.icon.code}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
      </v-list-tile>
      <div v-for="item in menu.items" :key="item.title">
        <v-list-group :value="true" v-if="item.childItems && item.childItems.length > 0 && item.title == 'Bookmarks'" class="sub-item-group-custom-style" noAction>
          <v-list-tile slot="activator">
            <v-list-tile-title>{{ item.title }} ({{item.childItems.length}})</v-list-tile-title>
          </v-list-tile>
          <LeafNode
            v-for="bookmark in item.childItems"
            :key="bookmark.route"
            :item="bookmark"
            class="indented"
            parentMenuLabel="Bookmarks">
          </LeafNode>
        </v-list-group>
        <v-list-tile class="indented no-group-styling" v-if="item.childItems && item.childItems.length == 0 && item.title == 'Bookmarks'">
          <router-link class="no-link-style" style="color:#ffffff;position:relative; width:100%" :to="item.route">
            <v-list-tile-title>Bookmarks (0)</v-list-tile-title>
          </router-link>
        </v-list-tile>
        <!-- Submenu items -->
        <v-list-group v-if="item.childItems && item.title !== 'Bookmarks'" class="sub-item-group-custom-style" noAction>
          <v-list-tile slot="activator">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
          <div v-for="childItem in item.childItems" :key="childItem.title">
            <v-list-group v-if="childItem.subSubItems" class="sub-item-group-custom-style" noAction>
              <v-list-tile slot="activator">
                <v-list-tile-title>{{ childItem.title }}</v-list-tile-title>
              </v-list-tile>
              <LeafNode
                v-for="subSubItem in childItem.subSubItems" :key="subSubItem.route"
                :item="subSubItem" class="indented sub-sub-item" :parentMenuLabel="childItem.title">
              </LeafNode>
            </v-list-group>
            <LeafNode :item="childItem" is-child-item v-else  :parentMenuLabel="item.title"></LeafNode>
          </div>
        </v-list-group>
        <LeafNode v-else-if="item.title !== 'Bookmarks'" :item="item" class="indented" :parentMenuLabel="menu.title"></LeafNode>
      </div>
    </v-list-group>

    <!-- No child menu links -->
    <v-list-group class="no-child">
    <v-list-tile slot="activator" v-if="!menu.items" :to="menu.route">
    <v-list-tile-action>
      <font-awesome-icon v-if="menu.icon && menu.icon.set" size="1x" :icon="[menu.icon.set, menu.icon.code]"></font-awesome-icon>
      <v-icon v-else-if="menu.icon && menu.icon.code">{{menu.icon.code}}</v-icon>
    </v-list-tile-action>
        <v-list-tile-title>{{menu.title}}</v-list-tile-title>
      <v-btn @click="createBookmark(menu)" class="bookmark-button" icon>
        <v-icon>bookmark</v-icon>
      </v-btn>
    </v-list-tile>
    </v-list-group>

  </div>
</template>

<script>
import LeafNode from "@/components/navigation/LeafNode"

export default {
  components: { LeafNode },
  props: {
    menu: {
      type: Object
    },
    menuGroupOpen: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    noBookmarks: { title: "Bookmarks (0)", route: "/" }
  }),
  methods: {
    createBookmark(data) {
      const bookmarkData = { route: data.route, linkText: data.title }
      this.$store.dispatch("createBookmark", bookmarkData)
    }
  }
}
</script>
  <style lang="css" scoped>
  .sub-item-group-custom-style {
    padding-left: 40px;
  }
  .sub-sub-item {
    padding-left: 20px;
  }
</style>
